import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import {validacion} from 'lib.common';

function TablaSimple({data, configuracion, noDataLabel, ...other}) {
   if (data.length === 0) {
      return <Typography>{noDataLabel}</Typography>;
   }
   return (
      <Table {...other}>
         <TableHead>
            <TableRow>
               {Object.keys(data[0]).map(item => {
                  let nombreCol = item;
                  let colProps = {};
                  let visible = true;
                  if (configuracion && configuracion[item]) {
                     const {titulo, valorMostrar, visible: visibleItem, ...other} = configuracion[
                        item
                     ];
                     nombreCol = titulo || item;
                     colProps = other;
                     visible = visibleItem && visible;
                  }
                  if (!visible) {
                     return null;
                  }
                  return (
                     <TableCell key={item} {...colProps}>
                        {nombreCol}
                     </TableCell>
                  );
               })}
            </TableRow>
         </TableHead>
         <TableBody>
            {data.map((fila, index) => {
               return (
                  <TableRow key={index}>
                     {Object.keys(data[0]).map((item, col) => {
                        let colProps = {};
                        let valor = null;
                        let visible = true;
                        if (configuracion && configuracion[item]) {
                           const {
                              titulo,
                              visible: visibleItem,
                              valorMostrar: valorFn,
                              ...other
                           } = configuracion[item];
                           valor = valorFn || valor;
                           colProps = other;
                           visible = visibleItem && visible;
                        }
                        if (!visible) {
                           return null;
                        }
                        let valorMostrar = validacion.esFuncion(valor) ? valor(fila) : fila[item];
                        return (
                           <TableCell key={col} {...colProps}>
                              {valorMostrar}
                           </TableCell>
                        );
                     })}
                  </TableRow>
               );
            })}
         </TableBody>
      </Table>
   );
}
TablaSimple.propTypes = {
   data: PropTypes.array.isRequired,
   configuracion: PropTypes.objectOf(
      PropTypes.shape({
         titulo: PropTypes.string,
         valorMostrar: PropTypes.func
      })
   ),
   noDataLabel: PropTypes.string
};
TablaSimple.defaultProps = {
   noDataLabel: 'No hay data para mostrar'
};
export default TablaSimple;
